// created_at/updated_at are intentionally absent: the API sorts on the
// partnerservice row but returns the deviceservice timestamps for those two, so
// a sorted column would not display in order. Unset => the API's default
// ordering.
export type DeviceSortBy = "name" | "username"
export type DeviceSortOrder = "asc" | "desc"

export interface DevicesSearch {
  offset?: number
  limit?: number
  subscriberId?: string
  search?: string
  partnerId?: string
  sortBy?: DeviceSortBy
  order?: DeviceSortOrder
}

const oneOf = <T extends string>(value: unknown, allowed: ReadonlyArray<T>) =>
  typeof value === "string" &&
  (allowed as ReadonlyArray<string>).includes(value)
    ? (value as T)
    : undefined

const str = (value: unknown) =>
  typeof value === "string" && value !== "" ? value : undefined

export function parseDevicesSearch(
  params: Record<string, unknown>,
): DevicesSearch {
  return {
    offset: typeof params.offset === "number" ? params.offset : undefined,
    limit: typeof params.limit === "number" ? params.limit : undefined,
    search: str(params.search),
    partnerId: str(params.partnerId),
    subscriberId: str(params.subscriberId),
    sortBy: oneOf(params.sortBy, ["name", "username"] as const),
    order: oneOf(params.order, ["asc", "desc"] as const),
  }
}
